import { del, get, post } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPIAPITokens {
    //This method returns all tokens associated with a customer account.
    getAllTokens() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/tokens",
        })));
    }
    //This method creates a new authentication token.
    createNewToken(params) {
        return operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: "/tokens",
            options: {
                body: params,
            },
        }));
    }
    //This method deletes an authentication token
    deleteToken(tokenId) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/tokens/${tokenId}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-api-tokens.js.map